<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-4 col-sm-12 col-xs-12">
        <div class="card" v-on:focus.native="onFocus">
          <div class="card-content">
            <vue-dropzone
              ref="uploadZone"
              id="dropzone"
              :options="dropzoneOptions"
              v-on:vdropzone-success-multiple="uploadSuccess"
              style="font-family: 'Roboto', Arial, Verdana; "
            ></vue-dropzone>
            <hr>
            <fieldset>
              <div class="form-group">
                <div class="col-sm-12">
                  <textarea
                    class="form-control"
                    v-model="uploadData.message"
                    placeholder="If you have special instructions or messages for our engineers, please put them here."
                    rows="3"
                  ></textarea>
                </div>
              </div>
            </fieldset>
            <hr>
            <div class="col-md-6 col-sm-6 col-xs-12">
              <img id="brandLogo" :src="brandLogoSrc" width="100" height="100">
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
              <br>
              <img id="serieImage" :src="serieImageSrc" width="150">
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12">
              <hr>
                <div class="card-title">
                  <small>Selected main tuning type</small>
                  <h5>{{ selectedTuningType.long_name }}</h5>
                </div>
                {{ selectedTuningType.content }}
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-content">
            <div class="form-group">
              <label class="col-md-4 control-label">Requested tuning types & Vehicle type</label>
              <el-select
                :class="{ 'select-warning' : !uploadData.tuning_type, 'select-success' : uploadData.tuning_type}" class="col-md-4"
                size="large"
                multiple
                placeholder="Select tuning type (multiple allowed!)"
                v-model="uploadData.tuning_type"
                v-validate="'required'"
                name="tuning type"
                @change="tuningTypeChanged($event)"
              >
                <el-option
                  v-for="(tuningtype, key) in tuningTypes"
                  class="select-primary"
                  :value="tuningtype.short_name"
                  :label="tuningtype.short_name"
                  :key="key"
                ></el-option>
              </el-select>
              <el-select
                :class="{ 'select-warning' : !uploadData.vehicle_type, 'select-success' : uploadData.vehicle_type}" class="col-md-4"
                size="large"
                placeholder="Select vehicle type"
                v-model="uploadData.vehicle_type"
                v-validate="'required'"
                name="vehicle type"
                @change="loadBrands($event)"
              >
                <el-option
                  v-for="vehicletype in vehicleData.types"
                  class="select-primary col-md-4"
                  :value="vehicletype.value"
                  :label="vehicletype.name"
                  :key="vehicletype.value"
                ></el-option>
              </el-select>
              <div class="clearfix"></div>
            </div>
              <hr>
              <h5
                v-show="errors.any()"
                class="invalid-feedback text-center"
              >Not all fields entered (correctly) - please fix this</h5>
              <br>
              <br>
              <button
                type="button"
                @click="process()"
                id="submitButton"
                class="btn btn-block btn-success"
                disabled
                data-tooltip="Upload some files first"
              >
                <i
                  class="fa"
                  :class="{'fa-upload': !uploadingFile, 'fa-circle-o-notch fa-spin fa-fw': uploadingFile}"
                  :disabled="uploadingFile"
                  aria-hidden="true"
                ></i> Upload file
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Input, Button, Select, Option } from "element-ui";
import swal from 'sweetalert2'
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import PSwitch from "src/components/UIComponents/Switch.vue";
export default {
  props: ["fileId"],
  components: {
    vueDropzone: vue2Dropzone,
    [Option.name]: Option,
    [Select.name]: Select,
    PSwitch
  },
  data: function() {
    return {
      tuningTypes: "",
      brandLogoSrc: "",
      serieImageSrc: "",
      vehicleData: {
        types: {},
        brands: {},
        series: {},
        builds: {},
        engines: {}
      },
      uploadingFile: false,
      fileData: "",
      customerData: "",
      productData: "",
      isVIN: true,
      ecuData: {
        brand: "",
        model: "",
        type: ""
      },
      uploadData: {
        tuning_type: "",
        additional_tuning: "",
        vehicle_type: "",
        files: "",
        ecu_brand: "",
        ecu_model: "",
        ecu_type: "",
        tool_type: "",
        accept_terms: false
      },
      ecuBrandList: "",
      ecuModelList: "",
      ecuTypeList: "",
      transmissionTypes: [
        {name: "manual"},
        {name: "automatic"},
        {name: "dsg"},
        {name: "dct"},
        {name: "other"}
      ],
      readMethods: [{
        name: "OBD"},
        {name: "BOOTMODE"},
        {name: "KTAG"},
        {name: "BDM"},
        {name: "other"
      }],
      tuningTools: '',
      tuningToolTypes: [
        {name: 'MASTER'},
        {name: 'SLAVE'},
        {name: 'Other / Unknown'}
      ],
      selectedTuningType: '',
      columns: ["fuel_type", "name", "slug", "hp", "kw", "actions"],
      dropzoneOptions: {
        paramName: "files",
        url: APIURL + "/files/upload",
        maxNumberOfFiles: 5,
        uploadMultiple: true,
        parallelUploads: 3,
        thumbnailWidth: 100,
        maxFilesize: 25,
        timeout: 180000,
        dictDefaultMessage:
          "<h1><i class='fa fa-cloud-upload-alt fa-2x'></i></h1><h3>upload your file(s) here...</h3>",
        headers: { Authorization: "Bearer " + Ls.get("access_key"), 'CTR-Access-Key': SITEKEY }
      },
      tblTicketsOptions: {
        childRow: function(h, row) {
          return row;
        }
      },
      tblTicketsUrl: "",
      tblTicketsColumns: ["created_at", "subject", "status", "created_by"]
    };
  },
  mounted: function() {
    this.loadTuningTypes();
    this.loadVehicleTypes();
    this.loadTuningTools();
    this.loadEcuBrands();
  },
  methods: {
    goBack() {
      $("html, body").animate({ scrollTop: 0 }, "fast");
      $('.nav-tabs a[href="#overviewTab"]').tab("show");
    },
    tuningTypeChanged(event) {
      this.tuningTypes.find((element) => {
        if(element.id = this.uploadData.tuning_type) {
          this.selectedTuningType = element;
        };
      });
    },
    loadTuningTypes() {
      if (!this.tuningTypes) {
        Webservice.getTuningTypes().then(resp => {
          this.tuningTypes = resp.data;
        });
      }
    },
    loadTuningTools() {
        Webservice.getTuningtools().then(resp => {
          this.tuningTools = resp.data;
        });
    },
    loadEcuBrands() {
      if (!this.ecuBrandList) {
        Webservice.getEcuBrands().then(resp => {
          this.ecuBrandList = resp.data;
        });
      }
    },
    loadEcuModels(event) {
        Webservice.getEcuModels(event).then(resp => {
          this.ecuModelList = resp.data;
        });
    },
    loadEcuTypes(event) {
      Webservice.getEcuTypes(event).then(resp => {
          this.ecuTypeList = resp.data;
        });
    },
    loadVehicleTypes() {
      Webservice.getVehicleTypes().then(resp => {
        this.vehicleData.types = resp.data;
      });
    },
    loadBrands(type) {
      Webservice.getBrands(type).then(resp => {
        this.vehicleData.brands = resp.data;
      });
    },
    brandChanged(brandId) {
      this.serieImageSrc = "";
      this.brandLogoSrc = "";

      Webservice.getBrandImage(brandId).then(response => {
        this.brandLogoSrc =
          "data:image/png;base64," +
          new Buffer(response.data, "binary").toString("base64");
      });
      Webservice.getSeries(brandId).then(resp => {
        this.vehicleData.series = resp.data;
      });
    },
    serieChanged(serieId) {
      this.serieImageSrc = "";
      Webservice.getSerieImage(serieId).then(response => {
        this.serieImageSrc =
          "data:image/png;base64," +
          new Buffer(response.data, "binary").toString("base64");
      });
      Webservice.getBuilds(serieId).then(resp => {
        this.vehicleData.builds = resp.data;
      });
    },
    buildChanged(buildId) {
      Webservice.getEngines(buildId).then(resp => {
        this.vehicleData.engines = resp.data;
      });
    },
    uploadSuccess(file, response) {
      if (response) {
        this.uploadData.files = response;
        $("#submitButton").prop("disabled", false);
        $("#submitButton").attr("data-tooltip", "Process upload");
        this.$notify(
          {
            component: {
              template: '<span>File upload succeeded, you can now continue!</span>'
            },
            icon: 'fas fa-check',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          });
      }
    },
    process() {
      if(this.uploadData.accept_terms == false) {
        swal({
        title: 'You have to accept the terms and conditions before you can continue',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        html: 'Please read them by clicking on the link and activate the checkbox!'
      });
      return false;
      }
      this.$validator.validateAll().then(result => {
        if (result === true) {
          Webservice.processUpload(
            this.uploadData
          )
            .then(response => {
              this.$notify(
              {
                component: {
                  template: '<span>Processing completed!</span>'
                },
                icon: 'fas fa-check',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'success'
              });
              // emit updates and show overview  
              this.$emit("update:loadedFileStatus", "saved");
              this.$emit("fileUploaded");
            })
            .catch((error) => {
              this.$notify(
              {
                component: {
                  template: '<span>Something went wrong during the process. Please retry or contact your account manager</span>'
                },
                icon: 'fas fa-exclamation-circle',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'warning'
              });
            });
        } else {
          toastr.warning(
            "Not all fields have been entered correctly. Please fix this and retry.",
            "Validation failed"
          );
        }
      });
    },
    readTicketmessage(ticketId) {
      this.$router.push({ name: "tickets", params: { ticketId: ticketId } });
    },

    showTermsConditions() {
      swal({
        title: 'Terms and Conditions',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        html: 'You can use <b>bold text</b>, ' +
        '<a href="http://github.com">links</a> ' +
        'and other HTML tags'
      })
    }
  }
};
</script>
<style scoped>
.bootstrap-switch {
  margin-top: 5px;
  margin-left: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/automaticUpload.vue